
import "./style_drdoc_lg.scss"
import "./res.js"

//console.log('Hello :)');
